<template>
    <b-card no-body  class="col-12 col-md-12">
        <b-modal v-bind:hide-footer="!PaymentErrorDetail.IsSentToBank && PaymentErrorDetail.Count >= 3 ? false:true" size="lg" id="detail" :title="''" no-close-on-esc no-close-on-backdrop>
            <payment-error-detail v-model="PaymentErrorDetail"></payment-error-detail>
            <template #modal-footer ><v-executer v-if="!PaymentErrorDetail.IsSentToBank &&  PaymentErrorDetail.Count >=3"  :loading="loading" :action="sendToBank"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { PaymentApi } from '@/api/payment'
import PaymentErrorDetail from './components/PaymentErrorDetail.vue'
export default {
    components:{
        BCard,
        PaymentErrorDetail
    },
    data(){
        return{
            loading:false,
            fields:[
                {name:'Banka',key:'BankStr',sortable:true, thClass:'w-10'},
                {name:'Tekrar Sayısı',key:'Count',sortable:true,thClass:'w-10'},
                {name:'Cari Kodu',key:'CustomerCode',sortable:true,thClass:'w-10'},
                {name:'Cari Adı',key:'CustomerName',sortable:true, thClass:'w-30'},
                {name:'Ödeme Kodu',key:'GroupCode',sortable:true, thClass:'w-20'},
                {name:'Bankaya Gönderildi Mi?',key:'IsSentToBank',sortable:true, thClass:'w-10'},
                {name:'Plasiyer',key:'PlasiyerName',sortable:false, thClass:'w-10'},
                
            ],
            buttons:[
                { text:"Detay Görüntüle",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.detail },
            ],
            PaymentErrorDetail:{
                Id:null,
                Bank:null,
                BankStr: null,
                Count: null,
                CustomerCode: null,
                CustomerName: null,
                GroupCode:null,
                IsSentToBank:null,
                PlasiyerCode:null,
                ErrorDetails:[]
            }
        }
    },
    methods:{
        sendToBank(){
            this.loading=true
            PaymentApi.Error.SendPaymentError(this.PaymentErrorDetail.Id).then(res => {
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('detail')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        clearForm(){
            this.PaymentErrorDetail.Id = null
            this.PaymentErrorDetail.Bank = null
            this.PaymentErrorDetail.BankStr = null
            this.PaymentErrorDetail.Count = null
            this.PaymentErrorDetail.CustomerCode = null
            this.PaymentErrorDetail.CustomerName = null
            this.PaymentErrorDetail.GroupCode = null
            this.PaymentErrorDetail.IsSentToBank = null
            this.PaymentErrorDetail.PlasiyerCode = null
            
        },
        provider(data){
            return PaymentApi.Error.PaymentErrrors(data)
        },
       
        edit(item){
            this.clearForm()
            this.PaymentErrorDetail.Id = item.Id
            this.PaymentErrorDetail.Bank = item.Bank
            this.PaymentErrorDetail.BankStr = item.BankStr
            this.PaymentErrorDetail.Count = item.Count
            this.PaymentErrorDetail.CustomerCode = item.CustomerCode
            this.PaymentErrorDetail.CustomerName = item.CustomerName
            this.PaymentErrorDetail.GroupCode = item.GroupCode
            this.PaymentErrorDetail.IsSentToBank = item.IsSentToBank
            this.PaymentErrorDetail.PlasiyerCode = item.PlasiyerCode
            this.PaymentErrorDetail.ErrorDetails = item.ErrorDetails
            this.$showModal('detail')
        },
        detail(item){
            this.$refs.table.rowLoading(true)
            PaymentApi.Error.PaymentErrorDetail(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.edit(res.data.Data)
                }
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        
    }
}
</script>

<style>

</style>